export enum CupStatuses {
  ReadyForCheckout = 1,
  CheckedOut,
  New,
  Retired,
  Returned,
  ReadyForDelivery,
  Purchased,
}
